import React, { Suspense, lazy, useEffect } from "react";
import SEO from "../seo/SEO";
import { SEO_PAGES, getBreadcrumbSchema } from "../seo/seoConfig";
import Spinner from "./ui/spinner";

const ForgeHero = lazy(() => import("./pages/forge/forge-hero"));
const ForgeAbout = lazy(() => import("./pages/forge/forge-about"));
const ForgeRoles = lazy(() => import("./pages/forge/forge-roles"));
const ForgeCurriculum = lazy(() => import("./pages/forge/forge-curriculum"));
const ForgeOutcomes = lazy(() => import("./pages/forge/forge-outcomes"));
const ForgeMentors = lazy(() => import("./pages/forge/forge-mentors"));
const ForgeFaq = lazy(() => import("./pages/forge/forge-faq"));
const ForgeVideos = lazy(() => import("./pages/forge/forge-videos"));
const ForgeApply = lazy(() => import("./pages/forge/forge-apply"));
const Footer = lazy(() => import("./footer"));

export const ForgePage = () => {
  const seo = SEO_PAGES.forge;

  useEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, []);

  return (
    <>
      <SEO
        {...seo}
        schemas={[
          getBreadcrumbSchema([
            { name: "Home", path: "/" },
            { name: "PYCRAY Forge", path: "/forge" },
          ]),
        ]}
      />
      <div id="forge">
        <main className="flex flex-col bg-white text-slate-900">
          <Suspense fallback={<Spinner />}>
            <ForgeHero />
          </Suspense>
          <Suspense fallback={<Spinner />}>
            <ForgeAbout />
          </Suspense>
          <Suspense fallback={<Spinner />}>
            <ForgeCurriculum />
          </Suspense>
          <Suspense fallback={<Spinner />}>
            <ForgeRoles />
          </Suspense>
          <Suspense fallback={<Spinner />}>
            <ForgeOutcomes />
          </Suspense>
          <Suspense fallback={<Spinner />}>
            <ForgeMentors />
          </Suspense>
          <Suspense fallback={<Spinner />}>
            <ForgeFaq />
          </Suspense>
          <Suspense fallback={<Spinner />}>
            <ForgeVideos />
          </Suspense>
          <Suspense fallback={<Spinner />}>
            <ForgeApply />
          </Suspense>
          <Suspense fallback={null}>
            <Footer />
          </Suspense>
        </main>
      </div>
    </>
  );
};

export default ForgePage;
